import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { ILoggedInUser } from "../../interfaces/common/loggedInUser";
import { LoggedInUserService } from "../../services/common/logged-in-user.service";
import { ReactiveFormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { EmployeeCategoriesService } from "../services/employee-categories.service";
import { EmployeeCategoryModel } from "../models/emloyee-categories.model";
import { ManageEmployeeCategoriesComponent } from "./manage-employee-categories/manage-employee-categories.component";

@Component({
  selector: "app-employee-categories",
  templateUrl: "./employee-categories.component.html",  
  standalone: true,  
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule, MatPaginatorModule, ReactiveFormsModule],
})
export class EmployeeCategoriesComponent implements OnInit {
  isLoading: boolean = false;
  dataSource: MatTableDataSource<EmployeeCategoryModel>;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  displayedColumns: string[] = ['number', 'description', 'from', 'to'];
  searchDone: boolean = false;

  constructor(
    private userService: LoggedInUserService,
    private employeeCategoriesService: EmployeeCategoriesService,    
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {   
    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;
        this.getAll()       
      }      
    });
    this.dialogClose()
  }

  getAll() {
    if(this.isAdmin){
      this.isLoading = true;
      this.employeeCategoriesService.searchEmployeeCategories().subscribe({
        next: (result) => {
          this.dataSource = new MatTableDataSource(result);
          this.isLoading = false;
          this.searchDone = true;
        },
        error: (err) => {
          console.error('Error get Employee Category: ', err);
          this.isLoading = false;
          this.searchDone = true;          
        }
      })
    }
  }

  dialogClose(){
    this.dialog.afterAllClosed.subscribe(data => {
      this.getAll();
    });
  }

  openDialog(item: string): void {
    if(this.isAdmin){
      if (item) {
        this.dialog.open(ManageEmployeeCategoriesComponent, {
          data: {
            code: item || "",          
          }
        });
      }else{
        this.dialog.open(ManageEmployeeCategoriesComponent, {
          data: {         
            code: "",
          }
        });
      }
    }    
  }
}
